export enum CustomerSessionDetailsTabs {
  SESSION_DETAILS = 'Session Details',
  TRACK_DETAILS = 'Track Details',
  FILES_MANAGEMENT = 'Files Management',
  MESSAGES = 'Messages'
}
